import React, { useState, useEffect, useRef } from "react";
import { HangPlusIcon } from './component/HangPlusIcon';
import { useHistory } from "react-router-dom";
import { constantConfig } from 'web-common';
import { 
	DEVELOPMENT_HISTORY_LIST, COMPANY_PROFILES, COMPANY_HONER_IMAGES, 
	ABOUTUS_STATIC_IMAGES, AboutAnchorEnum, JZFZ_IN_CHINA, LEADING_CONTENTS,
} from './config/index';
import useWindowResize from '../../hooks/useWindowResize';
import { CHAIRMAN_BOSS, SHAREHOLDER_BOSS } from './config/shareholder';
import { generateClassName, getQueryParams } from '../../util/common';
import { BannerPoster } from '../common/BannerPoster';

import './style/indexPC.less';

const { WEBSITE_PATHS } = constantConfig;

interface AboutUsPCProps {
	companyList: any[]; // 公司列表
}


/**
 * 企业文化红色间隔线
 * @returns
 */
const renderCompanyCultureGapLine = () => (
	<div className="w h1 pr" style={{background: '#FF1D38'}}>
		<HangPlusIcon position={{left: -40, top: -16}} />
		<HangPlusIcon  position={{right: -40, top: -16}} />
	</div>
);


/**
 * 关于我们,PC端
 * @constructor
 */
export const AboutUsPC = (props: AboutUsPCProps) => {

	const { anchor } = getQueryParams();
	const { companyList } = props;
	const history = useHistory();
	const [activeAnchor, setActiveAnchor] = useState<AboutAnchorEnum>(null); // 激活的锚点
	const [activeYear, setActiveYear] = useState<number>(2002); // 发展历程，展开的年份
	const [honorItemIndex, setHonorItemIndex] = useState<number>(null); // 荣誉图片索引

	// 公司简介Ui是否变形
	const [isProfileUiChange, setIsProfileUiChange] = useState<boolean>(false);

	// 公司简介锚点
	const profileRef = useRef<any>(null);
	// 企业文化锚点
	const cultureRef = useRef<any>(null);
	// 管理团队锚点
	const teamRef = useRef<any>(null);


	useEffect(() => {
		// 锚点
		handleAnchor(anchor);
	}, [anchor]);


	useWindowResize((rect: any) => {
		const { width } = rect;
		// 【公司简介】模块小于1750px时就会显示异常,需要特殊处理未遵循响应式原则设计的ui
		setIsProfileUiChange(width <= 1750);
	});


	useEffect(() => {
		// 监听滚动锚点事件
		const handleScroll = () => {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			let tempAnchor = null;
			if (scrollTop > 0) {
				if (scrollTop >= profileRef.current.offsetTop) {
					tempAnchor = AboutAnchorEnum.PROFILE;
				}
				if (scrollTop >= cultureRef.current.offsetTop) {
					tempAnchor = AboutAnchorEnum.CULTURE;
				}
				if (scrollTop >= teamRef.current.offsetTop) {
					tempAnchor = AboutAnchorEnum.TEAM;
				}
			}
			setActiveAnchor(tempAnchor);
		};
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);


	/**
	 * 处理锚点事件
	 * @param anchorId 
	 */
	const handleAnchor = (anchorId: AboutAnchorEnum) => {
		let currentRef = null;
		if (anchorId === AboutAnchorEnum.PROFILE) {
			currentRef = profileRef.current;
		}
		if (anchorId === AboutAnchorEnum.CULTURE) {
			currentRef = cultureRef.current;
		}
		if (anchorId === AboutAnchorEnum.TEAM) {
			currentRef = teamRef.current;
		}
		if (currentRef) {
			const offsetTop = currentRef.offsetTop;
			window.scrollTo({ 
				top: offsetTop, 
				behavior: "smooth" 
			});
			setActiveAnchor(anchorId);
		}
	};


	return (
		<div className="company-aboutUs-wrapper">

			{/* 左侧固定导航 */}
			<div className="side-navs f18 flexic">
                <div>
                    <a 
                        className={activeAnchor === AboutAnchorEnum.PROFILE ? 'active' : null}
                        onClick={() => {
							handleAnchor(AboutAnchorEnum.PROFILE); 
							history.replace(WEBSITE_PATHS.aboutUs);
						}}
                    >
                        公司简介
                    </a>
                    <div className="short-line" />
                    <a 
                        className={activeAnchor === AboutAnchorEnum.CULTURE ? 'active' : null}
                        onClick={() => {
							handleAnchor(AboutAnchorEnum.CULTURE); 
							history.replace(WEBSITE_PATHS.aboutUs);
						}}
                    >
                        企业文化
                    </a>
                    <div className="short-line" />
                    <a 
                        className={activeAnchor === AboutAnchorEnum.TEAM ? 'active' : null}
                        onClick={() => {
							handleAnchor(AboutAnchorEnum.TEAM); 
							history.replace(WEBSITE_PATHS.aboutUs);
						}}
                    >
                        管理团队
                    </a>
                </div>
            </div>

			{/* banner */}
			<div className="w banner ofh">
				<img src={ABOUTUS_STATIC_IMAGES.bannerPC} loading="lazy" className="imagec" />
				<div className="banner-poster-wrapper">
					<BannerPoster align="tl" />
				</div>
			</div>
 
			<div className="w aboutUs-content-container">
				{/* 黑字logo，文本介绍 */}
				<div ref={profileRef} className={generateClassName([
					"plrp10 mtb80 company-profile-pc",
					isProfileUiChange ? "company-profile-big-pad" : null
				])}>
					<div className="profile-logo">
						<img src={ABOUTUS_STATIC_IMAGES.logoBlack} alt="基准方中LOGO" loading="lazy" />
						<div className="flex ranking-info">
							<div className="ranking-item">
								<div><span className="black-title">全球</span></div>
								<div className="lh56"><img src={require('../../assets/images/aboutUs/TOP50.png')} alt="全球排行" /></div>
								<div className="deputy-title">
									<p>WA100 2025</p>
									<p>全球建筑设计公司榜单</p>
								</div>
								<div className="ranking-small-text">
									<p>
										GLOBAL TOP50 From WA100 2025 Global
										Architectural Design Firms Ranking
									</p>
								</div>
							</div>
							<div className="ranking-item">
								<div><span className="black-title">全国民营</span></div>
								<div className="lh56"><img src={require('../../assets/images/aboutUs/TOP3.png')} alt="全国民营" /></div>
								<div className="deputy-title">
									<p>中国勘察设计协会</p>
									<p>中国十大民营工程设计企业排行榜</p>
								</div>
								<div className="ranking-small-text">
									<p>
										TOP3 Nationwide From Ranking of Top 10 Private 
										Architectural Design Enterprises in China 
										Honored by China Survey and Design Association
									</p>
								</div>
							</div>
							<div className="ranking-item">
								<div>
									<span className="black-title"><img src={require('../../assets/images/aboutUs/TOP9.png')} alt="专业" />项专业</span>
								</div>
								<div><span className="black-title">全国领先</span></div>
								<div className="deputy-title">
									<p>中国勘察设计协会</p>
									<p>中国十大民营工程设计企业排行榜</p>
								</div>
								<div className="ranking-small-text">
									<p>
										Pioneering Expertise in 9 Sectors From Ranking
										of Top 10 Private Architectural Design Enterprises 
										in China Honored by China Survey and Design Association
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="profile-detail-text">
						{
							COMPANY_PROFILES.map((v: string, vi: number) => (
								<p className={vi === COMPANY_PROFILES.length - 1 ? "f18" : "mb24 f18"} key={`${v}-${vi}`}>{v}</p>
							))
						}
					</div>
				</div>

				{/* 领先的xxxxx,红色背景和文字介绍 */}
				<div className="plrp10 flex leading-container">
					{
						LEADING_CONTENTS.map(v => {
							return (
								<div className="leading-item" key={v.enTitle[0]}>
									<div className="en-title">
										<p>{v.enTitle[0]}</p>
										<p className="eps">{v.enTitle[1]}</p>
									</div>
									<div className="ptb32 cn-title">
										<p>{v.title[0]}</p>
										<p className="eps">{v.title[1]}</p>
									</div>
									<div className="cn-detail">{v.detail}</div>
								</div>
							);
						})
					}
				</div>

				{/* 地图 */}
				<div className="plrp10 pt152 company-expansion-map">
					<div className="f40" style={{ color: '#222' }}>{JZFZ_IN_CHINA.title}</div>
					<div className="f28" style={{ color: '#FF1D38' }}>{JZFZ_IN_CHINA.enTitle}</div>
					<div className="mtb72" style={{ color: '#BBBBBB' }}>
						{companyList.map(v => <React.Fragment key={v.englishName}>{`${v.contactName} ${v.englishName} | `}</React.Fragment>)}
					</div>
					<div className="w tc">
						<img src={ABOUTUS_STATIC_IMAGES.jzfzInChinaMapImgURL} loading="lazy" style={{ width: '76%' }} />
					</div>
					<div className="w flexjc">
						<div className="flexjc tc mtb100">
							{JZFZ_IN_CHINA.details.map((v, vi) => {
								return (
									<div className="flex" key={vi}>
										<div className="jzfz-inchinamap-count">
											<div className="f40">{v.amount}</div>
											<div className="f20">{v.incident}</div>
										</div>
										{
											vi < JZFZ_IN_CHINA.details.length - 1 ? (
												<div className={generateClassName(["jzfz-inchinamap-line", "mlr100"])} title="线" />
											) : (null)
										}
									</div>
								);
							})}
						</div>
					</div>
				</div>

				{/* 发展历程 */}			
				<div className="development-history pr mt80">
					<div className="mlrp10">
						<div className="w h1 pr" style={{background: '#FF1D38'}}>
							<HangPlusIcon position={{left: -40, top: -16}} />
							<HangPlusIcon  position={{right: -40, top: -16}} />
						</div>
					</div>
					<div style={{height: 450, background: '#fff'}} title="占位" />
					<div style={{height: 190, background: '#F7F7F7'}} title="占位" />
					<div className="mlrp10 pr">
						<HangPlusIcon position={{left: -35, bottom: -20}} />
						<HangPlusIcon  position={{right: -35, bottom: -20}} />
					</div>
					<div className="plrp10 w history-detail">
						<div className="flexjs">
							<div className="pr">
								<div className="history-list flex">
									{
										DEVELOPMENT_HISTORY_LIST.map((v: any, i: number) => {
											if (activeYear === v.year) {
												return (
													<div key={v.year} className="history-item active">
														<span className="history-text f18">{activeYear === v.year ? v.text : null}</span>
														<span className="big-year">{v.year}</span>
													</div>
												);
											}
											return (
												<div key={v.year} className="history-item" onMouseEnter={() => setActiveYear((y => y === v.year ? null : v.year))}>
													<span className="history-year lh22">{v.year}</span>
												</div>
											);
											
										})
									}
								</div>
							</div>
							<div className="tr mt50">
								<div className="f40" style={{color: '#222'}}>发展历程</div>
								<div className="f28" style={{color: '#FF1D38'}}>Development</div>
								<div className="f28" style={{color: '#FF1D38'}}>History</div>
							</div>
						</div>	
					</div>
				</div>			


				{/* 企业荣誉 */}
				<div className="company-honor plrp10 pt120">
					<div className="f40" style={{color: '#222'}}>企业荣誉</div>
					<div className="f28" style={{color: '#FF1D38'}}>Enterprise Honors</div>
					<div className="ptb30" onMouseLeave={() => setHonorItemIndex(null)}>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(1)}>
							<img src={honorItemIndex === 1 ? COMPANY_HONER_IMAGES.usuallyHover1 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
							<HangPlusIcon position={{left: -22, top: -22}} />
							<span className="text flexic flexjc">全国勘察设计行业优秀民营企业</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
						</div>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(2)}>
							<img src={honorItemIndex === 2 ? COMPANY_HONER_IMAGES.usuallyHover2 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
							<span className="text flexic flexjc">四川省民营企业党建工作示范企业</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
						</div>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(3)}>
							<img src={honorItemIndex === 3 ? COMPANY_HONER_IMAGES.usuallyHover3 : COMPANY_HONER_IMAGES.usually3} loading="lazy" />
							<HangPlusIcon position={{left: -22, top: -22}} />
							<span className="text flexic flexjc">中国十大民营工程设计企业</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
						</div>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(4)}>
							<img src={honorItemIndex === 4 ? COMPANY_HONER_IMAGES.usuallyHover4 : COMPANY_HONER_IMAGES.usually4} loading="lazy" />
							<span className="text flexic flexjc">四川省厂务公开民主管理示范单位</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
						</div>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(5)}>
							<img src={honorItemIndex === 5 ? COMPANY_HONER_IMAGES.usuallyHover5 : COMPANY_HONER_IMAGES.usually5} loading="lazy" />
							<HangPlusIcon position={{left: -22, top: -22}} />
							<span className="text flexic flexjc">当代中国建筑设计百家名院</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
						</div>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(6)}>
							<img src={honorItemIndex === 6 ? COMPANY_HONER_IMAGES.usuallyHover6 : COMPANY_HONER_IMAGES.usually6} loading="lazy" />
							<span className="text flexic flexjc">四川省优秀民营企业</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
						</div>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(7)}>
							<img src={honorItemIndex === 7 ? COMPANY_HONER_IMAGES.usuallyHover7 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
							<HangPlusIcon position={{left: -22, top: -22}} />
							<span className="text flexic flexjc">四川省首批总部企业</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
							<HangPlusIcon position={{left: -22, bottom: -22}} />
							<HangPlusIcon position={{right: -22, bottom: -22}} />
						</div>
						<div className="honor-item" onMouseEnter={() => setHonorItemIndex(8)}>
							<img src={honorItemIndex === 8 ? COMPANY_HONER_IMAGES.usuallyHover8 : COMPANY_HONER_IMAGES.usuallyEmpty} loading="lazy" />
							<span className="text flexic flexjc">成都市百强民营企业</span>
							<HangPlusIcon position={{right: -22, top: -22}} />
							<HangPlusIcon position={{right: -22, bottom: -22}} />
						</div>
					</div>
				</div>

				{/* 企业文化 */}
				<div ref={cultureRef} className="company-culture plrp10 ptb80">
					<div className="f40 tr" style={{color: '#222'}}>企业文化</div>
					<div className="f28 tr mb16">Enterprise Honors</div>
					{renderCompanyCultureGapLine()}
					<div className="mtb12 ptb50 flexic culture1">
						<span className="dib f40 pl12" style={{width: '50%'}}>愿景</span>
						<span className="dib f18" style={{width: '50%'}}>成为中国一流，具有世界影响力的大型工程设计咨询管理企业，促进建筑、城乡和社会的可持续发展。</span>
					</div>
					{renderCompanyCultureGapLine()}
					<div className="mtb12 ptb50 flexic culture2">
						<span className="dib f40 pl12" style={{width: '50%'}}>使命</span>
						<span className="dib f18" style={{width: '50%'}}>为城乡建筑投资商提供咨询、设计、管理的全面解决方案，为城乡和建筑的可持续发展贡献心力。</span>
					</div>
					{renderCompanyCultureGapLine()}
					<div className="mtb12 ptb50 flexic culture3">
						<span className="dib f40 pl12" style={{width: '50%'}}>核心价值观</span>
						<span className="dib f18" style={{width: '50%'}}>诚信守法、成就客户、持续创新、专业服务、团队合作。</span>
					</div>
					{renderCompanyCultureGapLine()}
					<div className="mtb12 ptb50 flexic culture4">
						<span className="dib f40 pl12" style={{width: '50%'}}>发展观</span>
						<span className="dib f18" style={{width: '50%'}}>共同创造、共同发展、共同分享、共同成就。让员工更满意、让客户更满意、促进社会和谐可持续发展。</span>
					</div>
					{renderCompanyCultureGapLine()}
				</div>

				{/* 管理团队 */}
				<div ref={teamRef} className="company-management-team">
					<div className="pb100" style={{background: '#F7F7F7'}}>
						<div className="mlrp10">
							<div className="f40" style={{color: '#222'}}>管理团队</div>
							<div className="f28 pb50" style={{color: '#FF1D38'}}>Management Team</div>	
						</div>
					</div>
					<div className="plrp10">
						<div className="team-list">
							<div className="flexjs mb60 big-boss">
								<div className="flexie flex1">
									<div className="w plr48 pb48">
										<div className="f72">{CHAIRMAN_BOSS.name}</div>
										<p className="f20 ptb12">{CHAIRMAN_BOSS.contents[0]}</p>
										<div className="h2 mb12" style={{background: '#FF1D38'}} />
										<p className="f20 lh48">{CHAIRMAN_BOSS.contents[1]}</p>
										<p className="f20 lh48">{CHAIRMAN_BOSS.contents[2]}</p>
									</div>
								</div>
								<div className="avatar"><img src={CHAIRMAN_BOSS.avatar} loading="lazy" /></div>
							</div>
							<div className="other-boss">
								{
									SHAREHOLDER_BOSS.map(item => { 
										const { name, titles, avatar, contents } = item;
										return (
											<div key={name} className="boss-item">
												<div className="flexjs">
													<div className="flex1 pt30">
														<div className="w pr24">
															<div className="f40">{name}</div>
															{titles.map(text => <p key={text} className="f14 pb12 b">{text}</p>)}
															<div className="h2 mb12" style={{background: '#F2F2F2'}} />
															{contents.map(v => (<p key={v} className="f14 lh20 mt6">{v}</p>))}
														</div>
													</div>
													<div className="avatar">
														<img src={avatar} loading="lazy" />
													</div>
												</div>
											</div>
										);
									})
								}
							</div>
						</div>
					</div>
				</div>

				{/* 总结 */}
				<div className="tr plrp10 ptb30" style={{color: '#DDDDDD'}}>
					<BannerPoster />
				</div>

				{/* 页尾导航 */}
				<div className="flexic flexjce flexe mtb30 lh16 plrp10">
					<div className="dib crp tc mr48" onClick={() => history.replace(WEBSITE_PATHS.home)}>
						<div style={{color: '#ADADAD'}}>首页</div>
						<div className="f12" style={{color: '#D4D4D4'}}>HOME</div>
					</div>
					<div className="dib w2 h28 mr48" style={{background: '#ADADAD'}} />
					<div className="dib crp tc mr48" onClick={() => history.replace(WEBSITE_PATHS.news)}>
						<div style={{color: '#ADADAD'}}>动态</div>
						<div className="f12" style={{color: '#D4D4D4'}}>NEWS</div>
					</div>
					<div className="dib crp tc mr48" onClick={() => history.replace(WEBSITE_PATHS.product)}>
						<div style={{color: '#ADADAD'}}>作品</div>
						<div className="f12" style={{color: '#D4D4D4'}}>PROJECTS</div>
					</div>
					<div className="dib crp tc mr48" onClick={() => history.replace(WEBSITE_PATHS.news)}>
						<div style={{color: '#ADADAD'}}>奖项</div>
						<div className="f12" style={{color: '#D4D4D4'}}>AWARDS</div>
					</div>
					<div className="dib crp tc" onClick={() => history.replace(WEBSITE_PATHS.contactUs)}>
						<div style={{color: '#ADADAD'}}>联系</div>
						<div className="f12" style={{color: '#D4D4D4'}}>CONTACTS</div>
					</div>
				</div>
			</div>
		</div>
	)
};
